// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"3c499208","361":"d4d9c38c","767":"044390fc"}[chunkId] + ".chunk.js";
};